// @flow
// Статусы студентов
export const PENDING: 'pending' = 'pending'; // В ожидании приема
export const EXPELLED: 'expelled' = 'expelled'; // Отчислен
export const ACTIVE: 'active' = 'active'; // Активный
export const GRADUATED: 'graduated' = 'graduated'; // Выпускник
